import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { deleteHerbicideTreatment } from '@/services/delete-herbicide-treatment'
import { queryClient } from '@/services/query-client'

import { GET_HERBICIDE_TREATMENTS_QUERY } from '../queries/use-get-herbicide-treatments'

export function useDeleteHerbicideTreatment() {
  return useMutation({
    mutationFn: deleteHerbicideTreatment,
    onSuccess: () =>
      queryClient.invalidateQueries([...GET_HERBICIDE_TREATMENTS_QUERY]),
    onError: (error: Error) =>
      toast.error(
        `Não foi possível carregar as informações, tente novamente. [${error?.message}]`,
      ),
  })
}
